export const TableHelpers = {
    data() {
        return {
            tableColumns : [
                {
                    title: 'ID',
                    type: 'text',
                    key: 'id',
            
                },
                {
                    title: this.$t('time'),
                    type: 'text',
                    key: 'event_start_time',
            
                },
                {
                    title: 'Sport',
                    type: 'text',
                    key: 'sport',
            
                },
                /*{
                    title: this.$t('name'),
                    type: 'text',
                    key: 'name',
            
                },*/
                {
                    title: 'Team 1',
                    type: 'text',
                    key: 'team1',
            
                },
                {
                    title: 'Team 2',
                    type: 'text',
                    key: 'team2',
            
                },
                {
                    title: 'League',
                    type: 'text',
                    key: 'league',
            
                },
                {
                    title: 'Full time',
                    type: 'wdw',
                    key: 'wdw',
            
                },
                {
                    title: 'Asian handicap',
                    type: 'ah',
                    key: 'asian',
            
                },
                {
                    title: 'Over / Under',
                    type: 'ou',
                    key: 'totals',
            
                },
                {
                    title: this.$t('action'),
                    type: 'action',
                },
            ],
        }
    },
}